import SafeHTML from '../SafeHTML';
import { CopyTextStyled } from './Copytext.styles';

/**
 * @param {CopytextProps} props
 * @returns {React.ReactElement} The rendered component
 */

export const Copytext = ({
  className,
  children,
  richtext,
  dataId,
  onClick,
}) => (
  <div className="richText" data-id={`${dataId}-container`} onClick={onClick}>
    {richtext ? (
      <SafeHTML
        as={CopyTextStyled}
        className={className}
        html={richtext}
        data-id={`${dataId}-richText`}
      />
    ) : (
      <span className={className} data-id={`${dataId}-span`}>
        {children}
      </span>
    )}
  </div>
);

export default Copytext;
